module.exports = __webpack_public_path__ + "assets/img/JoinTeam.2a80de70.png";